// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3fepK","errorLogs":"EditorFooter_errorLogs__1XEJt"};